import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getRmrAutomations = unaryRpc({
  name: "getRmrAutomations" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    automations: z.array(
      z.object({
        thirdPartyAccountId: z.string(),
        automationId: z.string(),
        threePlName: z.string(),
      }),
    ),
  }),
});
